<template>
  <div class="app-content ap note">
    <div class="row mb-3">
      <div class="col">
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__title">Note: {{ noteTitle }}</h1>
        </div>
      </div>
      <div class="col-auto">
        <router-link to="/dashboard" class="btn btn-primary">Back to Dashboard</router-link>
      </div>
    </div>
    <div class="content-block">
      <div class="content-block__header row">
        <div class="content-block__title col">Subnotes</div>
        <div class="content-block__actions col-auto">
          <ul>
            <li>
              <button class="subnote__button subnote__delete-subnotes" @click="deleteSubnotes" title="Delete selected subnotes"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
            </li>
          </ul>
        </div>
      </div>
      <div class="content-block__body">
        <div class="subnote" v-for="subnote in subnotes" :key="subnote.subnote_id">
          <div class="row">
            <div class="col-auto">
              <input type="checkbox" :id="subnote.subnote_id" :value="subnote" name="subnotes" v-model="checkedSubnotes">
            </div>
            <div class="col pl-0">
              <div class="row">
                <div class="col">
                  <p class="subnote__extract">Extract text</p>
                </div>
                <div class="col-auto ">
                  <button class="subnote__button subnote__download-subnote mr-3" @click="downloadSubnote(subnote)" title="Download note"><svg viewBox="0 0 512 512"><path d="M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z"/><path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z"/></svg></button> 
                  <button class="btn btn-primary btn-sm" @click="goToCheck(subnote)">Check</button>
                </div>
              </div>
              <p class="subnote__source"><span>Url</span> {{ subnote.link.url }}</p>
              <div class="subnote__text">
                {{ subnote.text }}
              </div>
              <ul class="subnote__taxonomies-list" v-if="subnote.taxonomies">
                <li v-for="taxonomy in subnote.taxonomies" :key="taxonomy" class="subnote__elem-taxonomy">
                  {{ getTaxonomyLabel(taxonomy) }}
                </li>
                <li v-for="target in subnote.targets" :key="target"  class="subnote__elem-target">
                  {{ getTargetLabel(target) }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { 
  FETCH_NOTE_SUBNOTES,
  SUBNOTE_DELETE,
  SUBNOTE_DOWNLOAD
} from "../store/actions.type";

export default {
  name: "Note",
  props: {
    noteTitle: String,
    folder: Object
  },
  data() {
    return {
      checkedSubnotes: []
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentFolder", "subnotes", "taxonomies", "targets"])
  },
  methods: {
    getTaxonomyLabel(taxonomyId) {
      for (var i = 0; i <= this.taxonomies.length; i++) {
        if(this.taxonomies[i].tax_id == taxonomyId) {
          return this.taxonomies[i].label;
        }
      }
    },
    getTargetLabel(targetId) {
      for (var i = 0; i <= this.targets.length; i++) {
        if(this.targets[i].gandtarget_id == targetId) {
          return this.targets[i].label;
        }
      }
    },
    deleteSubnotes() {

      if(this.checkedSubnotes.length) {
        Swal.fire({
          title: 'Move to trash',
          text: "Are you sure you want to move this item(s) to the trash?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, move to trash!'
        }).then((result) => {
          if (result.value) {

            for (var i = this.checkedSubnotes.length - 1; i >= 0; i--) {
              this.$store.dispatch(SUBNOTE_DELETE, this.checkedSubnotes[i].subnote_id);
            }
            
            Swal.fire(
              'Moved to trash!',
              'Your item(s) has been moved to the trash.',
              'success'
            );
          }
        });
      } else {
        Swal.fire(
          'Nothing to delete!',
          'You must select at least one subnote.',
          'warning'
        );
      }
    },
    downloadSubnote(subnote) {
      let subnoteData = {
        id: subnote.subnote_id,
        name: subnote.link.title
      }
      this.$store.dispatch(SUBNOTE_DOWNLOAD, subnoteData);
    },
    goToCheck(subnote) {
      this.$router.push({ name: "Check", params: {
        subnote: subnote,
        folder: this.folder,
        returnTo: '/note/' + this.$route.params.slug,
        article: subnote.link
      }})
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    let payload = {
      'folder_slug': this.currentFolder.folder_slug,
      'note_slug': this.$route.params.slug
    }
    this.$store.dispatch(FETCH_NOTE_SUBNOTES, payload);  
  }
}
</script>

<style lang="scss">

.subnote {
  margin-bottom: rem(32px);

  &:last-child {
    margin-bottom: 0;
  }

  &__extract {
    color: $color-sunset;
    font-size: rem(18px);
    text-transform: uppercase;
    margin-bottom: rem(8px);
  }

  &__source {
    font-family: $font-family-roboto;
    font-size: rem(14px);
    margin-bottom: rem(8px);

    span {
      text-transform: uppercase;
      margin-right: rem(16px);
      font-weight: 700;
    }
  }

  &__text {
    font-family: $font-family-roboto;
    margin-bottom: rem(16px);
  }

  &__taxonomies-list {
    font-family: $font-family-montserrat;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      font-size: rem(12px);
      padding: rem(4px) rem(8px);
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: $color-genoa;
      text-transform: uppercase;

      &:not(:first-child) {
        margin-left: rem(8px);
      }

      &.subnote__elem-target {
        color: $color-java;
      }
    }
  }

  &__button {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    svg {
      width: rem(28px);
      height: rem(28px);
      transition: fill .3s ease;
    }

    &:focus {
      outline: none;
    }
  }

  &__delete-subnotes {

    svg {
      width: rem(20px);
      height: rem(20px);
      fill: $color-genoa;
    }

    &:hover {

      svg {
        fill: $color-java;
      }
    }
  }

  &__download-subnote {

    &:focus {

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;

      &:hover {
        fill:$color-java;
      }
    }
  }
}

</style>